import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { PatientQuestionnaireControllerApi } from "../../../../services";
import {
  getConfigObject,
  getXtenantId,
  useBaseContent,
} from "../../../../utils/utils";
import { OptionData } from "../use-assessment-get";

type Props = {
  patientId: string;
  screenerTypes?: Array<string>;
  monthFilter?: { fromDate: string; toDate: string };
};

/**
 *
 * @author [Rajkumar Rathod]
 */
export const useGraphAssessment = ({
  patientId,
  screenerTypes,
  monthFilter,
}: Props): useBaseContent<OptionData> => {
  return useQuery({
    queryKey: ["graph-assessment", patientId, screenerTypes, monthFilter],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      await new PatientQuestionnaireControllerApi(getConfigObject())
        .getPatientQuestionnaireByScreenerTypes(
          patientId,
          monthFilter?.fromDate as string,
          monthFilter?.toDate as string,
          screenerTypes,
          getXtenantId() as any
        )
        .then((res) => res?.data),
  });
};
